import type { ChinaMapRegionId } from "@-/dev.improve.haniverse.data.china-map";

/**
 * The regions whose maps have place content and missions. Taiwan, Hong Kong and Macau maps exist
 * but have none yet, and a map that only says "Coming Soon" reads as unfinished to App Review
 * (guideline 2.1), so they are not offered until their content ships. Add a region here once it
 * has places.
 */
export const AVAILABLE_MAP_REGION_IDS: readonly ChinaMapRegionId[] = ["mainland"];

/** Whether the Map offers a choice of regions (its toolbar tabs). */
export const HAS_MAP_REGION_CHOICE = AVAILABLE_MAP_REGION_IDS.length > 1;

/** The region a stored choice resolves to: an unavailable one falls back to Mainland China. */
export function resolveAvailableMapRegionId(regionId: ChinaMapRegionId): ChinaMapRegionId {
  return AVAILABLE_MAP_REGION_IDS.includes(regionId) ? regionId : "mainland";
}
